export default __webpack_public_path__ + "8f8127fd64c16abc7f210ad5a7c36d24.png";